import { jsx } from '@emotion/core'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { checkmark_16 } from '@trustpilot/icons';
import { StyledItem, StyledIcon } from './styled';

var Item = function Item(_a) {
  var _b = _a.checked,
      checked = _b === void 0 ? false : _b,
      children = _a.children,
      onClick = _a.onClick,
      _c = _a.isPlaceholder,
      isPlaceholder = _c === void 0 ? false : _c,
      value = _a.value;

  function click() {
    if (onClick) {
      onClick(value);
    }
  }

  if (isPlaceholder) {
    return jsx(StyledItem, {
      active: checked,
      isPlaceholder: isPlaceholder
    }, children);
  }
  /* eslint-disable @typescript-eslint/camelcase */


  return jsx(StyledItem, {
    onClick: click,
    active: checked,
    isPlaceholder: isPlaceholder
  }, jsx(StyledIcon, {
    checked: checked,
    content: checkmark_16
  }), children);
  /* eslint-enable */
};

export default Item;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/select/item.js
// module id = 377
// module chunks = 0